const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
//Include this file in bot.js and follow examples for other modules. The questions will be rendered in the server side -Rich

class CopayModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `copay-module ${cssVariableKey}`);
    this.contentHash = {};
    this.typingIndicator = null;

  }

  handle(type, value, reference) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleTypingOnClick(component) {
    //handle click
    const singleSelectEl = component._option._element.getELM();
    const buttons = singleSelectEl.getElementsByClassName('option');
    
    const addTyping = () => {
      this.parent && this.parent.showTyping && this.parent.showTyping();
    };

    for (const button of buttons) {
      button.addEventListener("click", addTyping, false);
    }
  }

  handleOnMessage(value) {
    const questionOrCCInput = value.values;
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id,
        valueFormat = (((value || {}).values || {}).format || '');

    if ((valueFormat.indexOf("yes/no-back-3") > -1) && (identifier || '').indexOf("/answer") == -1) {
      this.contentHash = {};
    } 
    
    const ks = Object.keys(this.contentHash);
    
    if(ks.length && identifier.indexOf("/answer") === -1) {
      const lastK = this.contentHash[ks[ks.length - 1]];

      if(lastK && lastK.length) {
        const lastComp = lastK[1] || {};
        const lastId = ((lastComp._data || {}).id || '').split('/').pop();

        if ((identifier || '').split('/').pop() == 1 && lastId != 1) {
          this.reset();
        }
      }
    }

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];

      if(identifier && this.contentHash[identifier]) {
        const question = this.contentHash[identifier][1];
        question.updateAnswer(value.values, this.clearAfterId.bind(this));

        if(question && question._data && question._data.id && 
          (question._data.id.endsWith('copay/3') || question._data.id.endsWith('copay/10') || question._data.id.endsWith('copay/11'))) {
          //C.A. when user press "next" in the last question, exists a little delay that the chatbot looks like "frozen",
          //we need to show "TYPING" until the next question/component comes to the UI
          this.parent && this.parent.showTyping && this.parent.showTyping();
        }
      }
    } else if (!this.contentHash[identifier]) {
      const ccParams = { data: {} };

      if (questionOrCCInput.name && questionOrCCInput.number && questionOrCCInput.cvc) {
        for (let p in questionOrCCInput) {
          ccParams.data[p] = questionOrCCInput[p];
        }

        ccParams.data.label = questionOrCCInput.formLabel;
        ccParams.data.text = questionOrCCInput.text;
        ccParams.data.subtext = questionOrCCInput.subtext;
        ccParams.data.format = "creditcard";
        ccParams.data.values = questionOrCCInput.values;

        component = new Block(ccParams);
      } else {
        ccParams.data = questionOrCCInput;
        component = new Block(ccParams);
      }

      if(value.values && value.values.id && value.values.id.endsWith("copay/1")){
        this.handleTypingOnClick(component);
      }

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];

        if (value.values && value.values.error && component._option._element.handleOnError) {
          component._option._element.handleOnError(value.values.error, value.values.transactionId, false);
        }
      }
    } else {
      component = this.contentHash[identifier][1];
      if (value.values && value.values.error && component._option._element.handleOnError) {
        component._option._element.handleOnError(value.values.error, value.values.transactionId);
      }

      if(value.values && value.values.id && value.values.id.endsWith("copay/1")){
        //handle click
        this.handleTypingOnClick(component);
      }
    }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  reset() {
    this.elContainer.innerHTML = "";
    this.contentHash = {};
  }

  clearAfterId(id) {
    const index = (this.contentHash[id] || [])[0];
    const newHash = {};
    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index || ((ch[1] || {})._data || {}).format == "creditcard") {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;

    //remove questions from parent when the edit come from outside to inside of the module
    if(this.parent && this.parent.contentHash && this.parent.contentHash[this.value.id]) {
      const currentIndex = this.parent.contentHash[this.value.id][0];//index
      Object.keys(this.parent.contentHash).forEach(pKey => {
        const ch = this.parent.contentHash[pKey];
        if(ch[0] > currentIndex) {
          delete this.parent.contentHash[pKey];
          this.parent.elContainer.removeELM(ch[1]);
        }
      });
    }
  }

  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }
}

module.exports = CopayModule;
